import { useMemo } from 'react';
import { StatusPromotionType } from '@tiendanube/common';
import { cirrusApi } from 'App/rtk';
import { PromotionsEndpoints } from '../promotionsApi';

interface UsePromotionStatusProps {
  id: string | undefined;
}

interface UsePromotionStatusResult {
  status: StatusPromotionType | undefined;
  isLoading: boolean;
}

export function usePromotionStatus({
  id,
}: UsePromotionStatusProps): UsePromotionStatusResult {
  const queryResult = cirrusApi.endpoints[
    PromotionsEndpoints.promotionsList
  ].useQuery({ search: id }, { skip: !id });

  const { data, isLoading } = queryResult;

  const status = useMemo(() => {
    if (!data?.results || !id) return undefined;

    const promotion = data.results.find((item) => item.id === id);
    return promotion?.status;
  }, [data?.results, id]);

  return {
    status,
    isLoading,
  };
}
